import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Types
import Reducers from "types/Reducers";
// Async
import { registerUser, logoutUser } from './authAsync';

interface IState {
  resultId: string | null;
  userId: string | null;
  registerData: any;
  analyticData: any;
};

const initialState:IState = {
  resultId: null,
  userId: null,
  registerData: null,
  analyticData: null
};

const slice = createSlice({
  name: Reducers.Auth,
  initialState,
  reducers: {
    setResultId: (state, action:PayloadAction<string>) => {
      state.resultId = action.payload;
    },
    setUserId: (state, action:PayloadAction<string>) => {
      state.userId = action.payload;
    },
    setRegisterData: (state, action:PayloadAction<any>) => {
      state.registerData = action.payload;
    },
    setAnalyticData: (state, action:PayloadAction<any>) => {
      state.analyticData = action.payload;
    },
  },
  extraReducers(builder) {
    // Register user
    builder.addCase(registerUser.pending, (state) => {
    });
    builder.addCase(registerUser.fulfilled, (state, action:PayloadAction<any>) => {
    });
    // Logout user
    builder.addCase(logoutUser.pending, (state) => {
    });
    builder.addCase(logoutUser.fulfilled, (state) => {
      state.resultId = null;
      state.userId = null;
    });
  },
});

export const { setResultId, setUserId, setRegisterData, setAnalyticData } = slice.actions;

export default slice.reducer;
